module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074cb_logo_200x200.74a53db6.png";